{
    "Profile_InsuranceApplicant.contactDetails": "FR: Applicant Contact Details (Mortgage Broker, Lawyer, Other)",
    "Profile_InsuranceApplicant.enterContactInformation": "FR: Applicant Contact Information",
    "Profile_InsuranceApplicant.realEstateAgentContactDetails": "FR: Real Estate Agent Contact Details",
    "Profile_InsuranceApplicant.realEstateAgentContactInformation": "FR: Real Estate Agent Contact Information",
    "Profile_InsuranceApplicant.buyerContactDetails": "FR: Buyer Contact Details",
    "Profile_InsuranceApplicant.buyerContactInformation": "FR: Buyer Contact Information",
    "Profile_InsuranceApplicant.buyerOfferStatus": "FR: Offer Status",
    "Profile_InsuranceApplicant.buyerOfferStatusDetails": "FR: Buyer Offer Status",
    "Profile_InsuranceApplicant.additionalInfo": "FR: Additional Info",
    "Profile_InsuranceApplicant.guestPartner": "FR: Guest Partner",
    "Profile_InsuranceApplicant.guestPartnerInformation": "FR: Guest Partner Contact Information",
    "Profile_InsuranceApplicant.certificateInformation": "FR: Certificate Information",
    "Profile_InsuranceApplicant.certificateOwnerType": "FR: Certificate Owner Type",
    "Profile_InsuranceApplicant.firstName": "FR: First Name",
    "Profile_InsuranceApplicant.lastName": "FR: Last Name",
    "Profile_InsuranceApplicant.email": "FR: Email",
    "Profile_InsuranceApplicant.phoneNumber": "FR: Phone Number",
    "Profile_InsuranceApplicant.relationshipToSeller": "FR: Relationship to Seller",
    "Profile_InsuranceApplicant.whatIsRelationship": "FR: What is your relationship to the seller?",
    "Profile_InsuranceApplicant.isSeller": "FR: Are you the seller?",
    "Profile_InsuranceApplicant.relationship": "FR: Relationship",
    "Profile_InsuranceApplicant.other": "FR: Other",
    "Profile_InsuranceApplicant.estimatedSalePrice": "FR: Estimated Sale Price",
    "Profile_InsuranceApplicant.minExpectedSaleAmount": "FR: Min Expected Sale Amount",
    "Profile_InsuranceApplicant.maxExpectedSaleAmount": "FR: Max Expected Sale Amount",
    "Profile_InsuranceApplicant.minAmountFormatted": "FR: Pre-Approval Range Min Amount",
    "Profile_InsuranceApplicant.maxAmountFormatted": "FR: Pre-Approval Range Max Amount",
    "Profile_InsuranceApplicant.preApprovalRangeMinAmountOverride": "FR: Pre-Approval Range Min Amount Override",
    "Profile_InsuranceApplicant.preApprovalRangeMaxAmountOverride": "FR: Pre-Approval Range Max Amount Override",
    "Profile_InsuranceApplicant.intendedOfferAmount": "FR: Intended Offer Amount"
}
